import React from 'react'
import { useNavigate } from 'react-router-dom'
import moment from 'moment'
import { MyProfileTabs } from '../../../pages/myProfile/MyProfile'

const OverviewMyProfile = ({ data, setTab }) => {
  const navigate = useNavigate()

  return (
    <>
      <div className='card mb-5 mb-xl-10'>
        <div className='card-header cursor-pointer'>
          <div className='card-title m-0'>
            <h3 className='fw-bold m-0'>Profile Details</h3>
          </div>
          <button
            type='button'
            className='btn btn-sm btn-primary align-self-center d-none'
            onClick={() => setTab(MyProfileTabs.settings)}
          >
            Edit Profile
          </button>
        </div>
        <div className='card-body p-9'>
          <div className='row mb-7'>
            <label className='col-lg-4 fw-semibold text-muted'>Full Name</label>
            <div className='col-lg-8'>
              <span className='fw-bold fs-6 text-gray-800'>{data?.name}</span>
            </div>
          </div>
          <div className='row mb-7'>
            <label className='col-lg-4 fw-semibold text-muted'>Email ID</label>
            <div className='col-lg-8 d-flex align-items-center'>
              <span className='fw-bold fs-6 text-gray-800 me-2'>{data?.email}</span>
            </div>
          </div>
          <div className='row mb-7'>
            <label className='col-lg-4 fw-semibold text-muted'>Contact Number</label>
            <div className='col-lg-8 d-flex align-items-center'>
              <span className='fw-bold fs-6 text-gray-800 me-2'>{data?.phone}</span>
            </div>
          </div>
          <div className='row mb-7'>
            <label className='col-lg-4 fw-semibold text-muted'>Account Type</label>
            <div className='col-lg-8'>
              <span className='fw-bold fs-6 text-gray-800'>{data?.type || '-'}</span>
            </div>
          </div>
          <div className='row mb-7'>
            <label className='col-lg-4 fw-semibold text-muted'>Member Since</label>
            <div className='col-lg-8'>
              <span className='fw-bold fs-6 text-gray-800'>
                {data?.created_at ? moment(data.created_at).format('DD MMM YYYY, hh:mm A') : '-'}
              </span>
            </div>
          </div>
        </div>
      </div>
    </>
  )
}

export default OverviewMyProfile
